// Dividends Mutations

export const updateDividendsList = (state, payload) => {
  state.dividendsList = payload
}

export const setDividendInfo = (state, payload) => {
  state.dividendInfo = payload
}

export const setIncomeAfterTax = (state, payload) => {
  state.incomeAfterTax = payload
}
